import { ref } from '@vue/composition-api'

export default function useWorkplaceActivate() {
  const workplaceActivateModal = ref(null)

  const workplaceActivate = ref({
    institution: null,
    workplace: null,
  })

  function show(workplace) {
    workplaceActivate.value = {
      institution: workplace.institution,
      workplace,
    }
    workplaceActivateModal.value.show()
  }

  return {
    workplaceActivateModal,
    workplaceActivate,
    show,
  }
}
